export const readBlobAs = (
  blob: Blob,
  type: 'ArrayBuffer' | 'DataURL' | 'Text',
): Promise<ArrayBuffer | string> =>
  new Promise(resolve => {
    const reader = new FileReader();

    // @ts-expect-error: TODO: describy why
    reader.onload = e => resolve(e.target.result);
    reader[`readAs${type}`](blob);
  });
